import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPut, doPostFiles, doDownload, doPost } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

//Attachments
export const getAttachments = (id) => {
  const url = `${API_ROOT}/proposal/${id}/attachments`
  return doGet(url)
}

//Progress
export const getProjectEvaluationProgress = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-progress`
  return doGet(url)
}

//Progress
export const saveProjectEvaluationProgress = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-progress/progress`
  return doPostFiles(url, request)
}

//Progress
export const saveProjectEvaluationEvaluation = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-progress/evaluation`
  return doPostFiles(url, request)
}

//Progress
export const getDownloadProjectEvaluation = (id, path) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-progress/download?path=${path}`
  return doDownload(url)
}

//Relation
export const getProjectEvaluationRelation = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-relation`
  return doGet(url)
}

//Relation
export const selectProjectEvaluationRelation = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-relation`
  return doPost(url, request)
}

//Relation
export const searchProjectEvaluationRelation = (id, param) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-relation/5/pagesize/1?${param}`
  return doGet(url)
}

//Relation
export const deleteProjectEvaluationRelation = (id, projectId) => {
  const url = `${API_ROOT}/proposal/${id}/project-evaluation-relation/${projectId}`
  return doDelete(url)
}

export const getAttachmentsByFileId = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/${fileId}`
  return doGet(url)
}
export const getDownload = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/${fileId}/download`
  return doDownload(url)
}

export const saveAttachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/attachments`
  return doPostFiles(url, request)
}

export const updateAttachments = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/${request.id}`
  return doPut(url, request)
}

export const deleteAttachments = (id, fileId) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/${fileId}`
  return doDelete(url)
}

export const changeAttachmentSeqNo = (id, fileId, seqNo) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/${fileId}/${seqNo}`
  return doPut(url)
}

export const getAllAttachments = (id) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/all`
  return doGet(url)
}

export const getOldInfomaAttachments = (id) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/infoma`
  return doGet(url)
}

export const allAttachmentsDownload = (id, filePath) => {
  const url = `${API_ROOT}/proposal/${id}/attachments/all/download?path=${filePath}`
  return doDownload(url)
}

export const completedContractAttachmentsDownload = (projectVersionId, filePath) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/attachments/econtract/download?url=${filePath}`
  return doDownload(url)
}

export const infomaAttachmentsDownload = (projectVersionId, filePath) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/attachments/infoma/download?url=${filePath}`
  return doDownload(url)
}

export const downloadFileMs = (filePath) => {
  const url = `${API_ROOT}${filePath}`
  return doDownload(url)
}
